let lastClickedLabel = null;
const observer = new MutationObserver(() => {
  const allSelectors = document.querySelectorAll('.single-option-selector');
  if (allSelectors.length >= 3) {
    const lastThree = Array.from(allSelectors).slice(-3);
    lastThree.forEach((selector, index) => {
      const label = selector.querySelector('label');
      if (label && !label.classList.contains('modified_inputs')) {
        label.classList.add('modified_inputs');
        label.addEventListener('click', function handleClick(event) {
          if (lastClickedLabel && lastClickedLabel !== label) {
            lastClickedLabel.click();
            console.log('Simulated click on previous label');
          }
          lastClickedLabel = label;
        });
        console.log(`Click listener added to label #${index + 1}`);
      }
    });
    observer.disconnect();
  }
});
observer.observe(document.body, { childList: true, subtree: true });
